package com.hyperether.goodjob.scenes.jobs

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.requiredHeight
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.text.selection.DisableSelection
import androidx.compose.material.MaterialTheme
import androidx.compose.material.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.draw.drawBehind
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.em
import androidx.navigation.NavHostController
import com.hyperether.goodjob.Dp
import com.hyperether.goodjob.boxCornerShape
import com.hyperether.goodjob.log
import com.hyperether.goodjob.resources.Res
import com.hyperether.goodjob.resources.are_you_sure
import com.hyperether.goodjob.resources.cancel
import com.hyperether.goodjob.resources.check_soon
import com.hyperether.goodjob.resources.confirmation
import com.hyperether.goodjob.resources.delete
import com.hyperether.goodjob.resources.jobs
import com.hyperether.goodjob.resources.location
import com.hyperether.goodjob.resources.no_tasks_assigned
import com.hyperether.goodjob.resources.no_tasks_created
import com.hyperether.goodjob.resources.site
import com.hyperether.goodjob.resources.status
import com.hyperether.goodjob.resources.time
import com.hyperether.goodjob.resources.title
import com.hyperether.goodjob.resources.upcoming_jobs
import com.hyperether.goodjob.resources.user
import com.hyperether.goodjob.scenes.components.PopUpDialog
import com.hyperether.goodjob.scenes.components.WebFilterButton
import com.hyperether.goodjob.scenes.components.WebSearchField
import com.hyperether.goodjob.scenes.components.WebViewHeader
import com.hyperether.goodjob.scenes.components.clickableWithPointer
import com.hyperether.goodjob.scenes.jobs.components.FilterJobsDialog
import com.hyperether.goodjob.scenes.jobs.components.JobListWeb
import com.hyperether.goodjob.theme.BorderColor
import com.hyperether.goodjob.theme.DashboardBg
import com.hyperether.goodjob.util.FilterDialogStateManager
import com.hyperether.goodjob.util.toScaleDp
import com.hyperether.goodjob.util.toScaleSp
import com.hyperether.goodjob.webDetailsTitle
import com.hyperether.resources.stringResource

@Composable
fun JobsWeb(
    isMobileView: Boolean,
    navController: NavHostController,
    viewModel: JobListViewModel
) {
    log.d("JobsWeb") { "recompose" }
    LaunchedEffect(Unit) {
        viewModel.init()
    }
    val isAllSelected = remember { mutableStateOf(false) }
    val searchText = remember { mutableStateOf("") }

    Column(
        modifier = Modifier
            .fillMaxSize()
            .background(DashboardBg)
    ) {
        WebViewHeader(
            isAddNewJob = true,
            isBackAvailable = false,
            title = stringResource(Res.string.jobs),
            isImportAndAddVisible = !viewModel.isEmployee(),
            navHostController = navController
        )
        Column(
            modifier = Modifier
                .fillMaxSize()
                .padding(horizontal = 75.toScaleDp(), vertical = 15.toScaleDp())
                .background(Color.White, shape = boxCornerShape())
                .border(
                    width = 1.toScaleDp(),
                    shape = boxCornerShape(),
                    color = BorderColor
                )
                .clip(MaterialTheme.shapes.medium)
        ) {
            Row(
                verticalAlignment = Alignment.CenterVertically,
                modifier = Modifier
                    .height(webDetailsTitle())
                    .drawBehind {
                        val strokeWidth = Dp(1f).toPx()
                        drawLine(
                            color = BorderColor,
                            start = Offset(0f, size.height - strokeWidth / 2),
                            end = Offset(size.width, size.height - strokeWidth / 2),
                            strokeWidth = strokeWidth
                        )
                    }
                    .padding(horizontal = 23.toScaleDp())
            ) {
                Column(
                    modifier = Modifier.weight(2f),
                ) {
                    Text(
                        text = stringResource(Res.string.upcoming_jobs),
                        fontSize = 24.toScaleSp(),
                        fontWeight = FontWeight.W700,
                        maxLines = 1,
                        overflow = TextOverflow.Ellipsis
                    )
                    if (viewModel.selectedJobs.isNotEmpty()) {
                        Text(
                            text = stringResource(Res.string.delete).lowercase()
                                .replaceFirstChar { if (it.isLowerCase()) it.titlecase() else it.toString() },
                            color = Color.Red,
                            fontSize = 16.toScaleSp(),
                            modifier = Modifier
                                .padding(top = 12.toScaleDp())
                                .clickableWithPointer {
                                    viewModel.showAreYouSurePopUpDeleteJob.value = true
                                },
                            maxLines = 1,
                            overflow = TextOverflow.Ellipsis
                        )
                    }
                }
                WebSearchField(
                    text = searchText.value,
                    onTextChange = {
                        searchText.value = it
                    }
                )
                Spacer(modifier = Modifier.width(16.toScaleDp()))

                if (viewModel.jobList.isNotEmpty()) {
                    WebFilterButton(
                        onClick = {
                            FilterDialogStateManager.setDialogShowing(true)
                        }
                    )
                    Spacer(modifier = Modifier.width(16.toScaleDp()))
                }

                // TODO: get options
//                            DropdownSortBy(
//                                shouldAppendSortBy = false,
//                                items = listOf("This week"),
//                                selectedValue = viewModel.jobSortBy.value ?: "This week",
//                                onValueSelected = { viewModel.jobSortBy.value = it },
//                                displayText = { it },
//                                placeholderColor = BorderColor,
//                                textColor = Color.Black,
//                                modifier = Modifier.height(Dp(55f))
//                            )
            }
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .background(color = Color(0xfffafafa))
                    .padding(horizontal = 22.toScaleDp())
                    .requiredHeight(38.toScaleDp()),
                verticalAlignment = Alignment.CenterVertically
            ) {
                Text(
                    text = stringResource(Res.string.title),
                    fontWeight = FontWeight.W700,
                    style = TextStyle(fontSize = 14.toScaleSp(), lineHeight = 1.5.em),
                    modifier = Modifier.weight(0.9f),
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis
                )
                Text(
                    text = stringResource(Res.string.site),
                    fontWeight = FontWeight.W700,
                    style = TextStyle(fontSize = 14.toScaleSp(), lineHeight = 1.5.em),
                    modifier = Modifier.weight(1.1f),
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis
                )
                Text(
                    text = stringResource(Res.string.location),
                    fontWeight = FontWeight.W700,
                    style = TextStyle(fontSize = 14.toScaleSp(), lineHeight = 1.5.em),
                    modifier = Modifier.weight(1.6f),
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis
                )
                Text(
                    text = stringResource(Res.string.time),
                    fontWeight = FontWeight.W700,
                    style = TextStyle(fontSize = 14.toScaleSp(), lineHeight = 1.5.em),
                    modifier = Modifier.weight(0.6f),
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis
                )
                Text(
                    text = stringResource(Res.string.user),
                    fontWeight = FontWeight.W700,
                    style = TextStyle(fontSize = 14.toScaleSp(), lineHeight = 1.5.em),
                    modifier = Modifier.weight(0.5f),
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis
                )
                Text(
                    text = stringResource(Res.string.status),
                    fontWeight = FontWeight.W700,
                    textAlign = TextAlign.Center,
                    style = TextStyle(fontSize = 14.toScaleSp(), lineHeight = 1.5.em),
                    modifier = Modifier.weight(0.5f),
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis
                )
            }
            if (viewModel.isEmployee() && viewModel.filteredJobs.isEmpty()) {
                androidx.compose.material3.Text(
                    text = stringResource(Res.string.no_tasks_created),
                    color = Color.Black,
                    fontSize = 24.toScaleSp(),
                    textAlign = TextAlign.Center,
                    fontWeight = FontWeight.Bold,
                    modifier = Modifier
                        .fillMaxWidth()
                        .padding(
                            top = 60.toScaleDp(),
                            start = 16.toScaleDp(),
                            end = 16.toScaleDp()
                        )
                )
                androidx.compose.material3.Text(
                    text = stringResource(Res.string.check_soon),
                    color = Color.Gray,
                    textAlign = TextAlign.Center,
                    fontSize = 16.toScaleSp(),
                    modifier = Modifier
                        .fillMaxWidth()
                        .padding(
                            top = 20.toScaleDp(),
                            start = 16.toScaleDp(),
                            end = 16.toScaleDp()
                        )
                )
            } else if (!viewModel.isEmployee() && viewModel.filteredJobs.size == 0) {
                viewModel.isInEditMode.value = false
                viewModel.showEditPopUp.value = false
                androidx.compose.material3.Text(
                    text = stringResource(Res.string.no_tasks_created),
                    color = Color.Black,
                    fontSize = 24.toScaleSp(),
                    textAlign = TextAlign.Center,
                    fontWeight = FontWeight.Bold,
                    modifier = Modifier
                        .fillMaxWidth()
                        .padding(
                            top = 60.toScaleDp(),
                            start = 16.toScaleDp(),
                            end = 16.toScaleDp()
                        )
                )
                androidx.compose.material3.Text(
                    text = stringResource(Res.string.no_tasks_assigned),
                    color = Color.Gray,
                    textAlign = TextAlign.Center,
                    fontSize = 16.toScaleSp(),
                    modifier = Modifier
                        .fillMaxWidth()
                        .padding(
                            top = 20.toScaleDp(),
                            start = 16.toScaleDp(),
                            end = 16.toScaleDp()
                        )
                )
            } else {
                JobListWeb(
                    sites = viewModel.sitesMap,
                    jobsSorted = viewModel.searchAndSortJobs(searchText.value),
                    navHostController = navController,
                    isAllSelected = isAllSelected.value,
                    onAllSelectedChange = { isChecked ->
                        isAllSelected.value = isChecked
                        viewModel.selectedJobs.clear()
                        if (isChecked) {
                            viewModel.selectedJobs.addAll(viewModel.jobList)
                        }
                    },
                    selectedJobs = viewModel.selectedJobs,
                    onJobSelectedChange = { jobId, isChecked ->
                        if (isChecked) {
                            viewModel.selectedJobs.add(jobId)
                        } else {
                            viewModel.selectedJobs.remove(jobId)
                        }
                        isAllSelected.value =
                            viewModel.selectedJobs.size == viewModel.jobList.size
                    }
                )
            }
        }
        if (viewModel.showAreYouSurePopUpDeleteJob.value) {
            DisableSelection {
                PopUpDialog(
                    onDismiss = { viewModel.showAreYouSurePopUpDeleteJob.value = false },
                    title = stringResource(Res.string.confirmation),
                    message = stringResource(Res.string.are_you_sure),
                    onPositiveBtnClicked = {
                        viewModel.showLoader.value = true
                        viewModel.deleteSelectedJobs(
                            onAllDeleted = {
                                viewModel.showLoader.value = false
                            },
                            onError = {
                                viewModel.showLoader.value = false
                            })
                        viewModel.showAreYouSurePopUpDeleteJob.value = false
                    },
                    onNegativeBtnClicked = {
                        viewModel.showAreYouSurePopUpDeleteJob.value = false
                    },
                    positiveBtnText = stringResource(Res.string.delete),
                    negativeBtnText = stringResource(Res.string.cancel)
                )
            }
        }
    }

    val userTeams = viewModel.getUser()?.teams
    if (FilterDialogStateManager.dialogShowing.value) {
        FilterJobsDialog(
            viewModel.getFilterMap(),
            onDismiss = {
                FilterDialogStateManager.setDialogShowing(false)
            },
            onApply = { map ->
                FilterDialogStateManager.setDialogShowing(false)
                viewModel.applyFilter(map)
                viewModel.filterJobs()
            },
            isMobileView = isMobileView,
            isEmployee = viewModel.isEmployee(),
            userTeams = userTeams
        )
    }
}